var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import './BulkEditModal.scss';
import classNames from 'classnames';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { DropdownModal } from '../';
import React from 'react';
export const BulkEditModal = (_a) => {
    var { children, getPopupContainer, className, disabled, targetNode, selectedCount, typeLabel } = _a, rest = __rest(_a, ["children", "getPopupContainer", "className", "disabled", "targetNode", "selectedCount", "typeLabel"]);
    const title = `${COPY_SPECIFIC.EDITING} ${selectedCount} ${typeLabel}`;
    const okText = `${COPY_SPECIFIC.UPDATE} ${selectedCount} ${typeLabel}`;
    return (React.createElement(DropdownModal, Object.assign({ className: classNames('bulk-edit-modal', className), fixedWidth: true, getPopupContainer: getPopupContainer, mask: false, okButtonProps: { disabled }, okText: okText, targetNode: targetNode, title: title, wrapClassName: 'bulk-edit-modal-wrapper' }, rest), children));
};
